package org.example.project.enginevertrieb

import androidx.compose.runtime.*
import org.example.project.settings.*
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
internal fun SalesConversationSteps(
    flowTypes: List<Map.Entry<String, List<All>>>, stage: Int, live: Boolean,
    usedElements: Set<String>, answers: Map<String, Set<Int>>,
    onUse: (String) -> Unit, onAnswersChange: (Map<String, Set<Int>>) -> Unit,
    onStageChange: (Int) -> Unit, log: (String, String) -> Unit
) {
flowTypes.forEachIndexed { index, (type, elements) ->
                            val step = index + 1
                            val orderedElements = elements.sortedWith(compareBy<All> { it.akquiseDefinitionPrio }.thenBy { it.akquiseDefinitionId })
                            ConversationStep(type, step, stage) {
                                orderedElements.forEachIndexed { elementIndex, element ->
                                    key(element.akquiseDefinitionId) {
                                        val elementId = element.akquiseDefinitionId
                                        val elementEnabled = live && stage == step
                                        val answerLabels = element.flowAntworten()
                                        val reactionLabels = element.flowReaktionen()
                                        val hasReactions = reactionLabels.any { it.isNotBlank() }
                                        Div({
                                            id("akquise-element-$step-$elementId")
                                            style {
                                                display(DisplayStyle.Grid)
                                                gridTemplateColumns("repeat(2, minmax(0, 1fr))")
                                                gap(22.px); alignItems(AlignItems.Stretch); width(100.percent)
                                                padding(14.px); marginBottom(8.px); boxSizing("border-box")
                                                borderRadius(10.px)
                                                backgroundColor(if (elementIndex % 2 == 0) Color("rgba(255,255,255,.055)") else Color("rgba(255,255,255,.025)"))
                                                property("border-bottom", "1px solid rgba(255,255,255,.10)")
                                            }
                                        }) {
                                            Div({ style { minWidth(0.px); minHeight(0.px); property("grid-column", "1 / -1"); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column) } }) {
                                                P({ style {
                                                    flex("1"); fontSize(18.px); lineHeight("1.45"); fontWeight("650")
                                                    margin(0.px); padding(10.px, 12.px); boxSizing("border-box")
                                                    display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.Center)
                                                    textAlign("center"); property("overflow-wrap", "anywhere")
                                                } }) {
                                                    if (elementId in usedElements) Span({ attr("aria-label", "Verwendet") }) { Text("✓ ") }
                                                    Span({ style { property("white-space", "pre-wrap") } }) { Text(element.akquiseDefinitionText) }
                                                }
                                            }
                                            Div({ style { minWidth(0.px); minHeight(150.px); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); justifyContent(JustifyContent.Center) } }) {
                                                Div({ style {
                                                    display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(14.px)
                                                    width(100.percent); alignItems(AlignItems.Stretch)
                                                } }) {
                                                answerLabels.forEachIndexed { answerIndex, label ->
                                                    val displayedLabel = if (element.akquiseDefinitionAntwortTypen.getOrNull(answerIndex) == "Einwand") "Einwand: $label" else label
                                                    if (label.isNotBlank()) FlowChoiceRow(displayedLabel, answerIndex in answers[elementId].orEmpty(), elementEnabled) {
                                                        onUse(elementId)
                                                        onAnswersChange(answers + (elementId to (answers[elementId].orEmpty().filterNot { it in 0 until answerLabels.size } + answerIndex).toSet()))
                                                        log(type, "${element.akquiseDefinitionText} [${elementId}]: ${label}")
                                                    }
                                                }
                                            }
                                            }
                                            Div({ style {
                                                minWidth(0.px); minHeight(150.px); boxSizing("border-box")
                                                property("border-left", if (hasReactions) "1px solid rgba(255,255,255,.12)" else "none")
                                                property("padding-left", if (hasReactions) "12px" else "0")
                                                display(DisplayStyle.Flex); alignItems(AlignItems.Center); justifyContent(JustifyContent.Center)
                                            } }) {
                                                Div({ style { width(100.percent); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(14.px) } }) {
                                                    reactionLabels.forEachIndexed { reactionIndex, reaction ->
                                                        val choiceIndex = answerLabels.size + reactionIndex
                                                        if (reaction.isNotBlank()) FlowChoiceRow(reaction, choiceIndex in answers[elementId].orEmpty(), elementEnabled) {
                                                            onUse(elementId)
                                                            onAnswersChange(answers + (elementId to (answers[elementId].orEmpty().filterNot { it >= answerLabels.size } + choiceIndex).toSet()))
                                                            log(type, "${element.akquiseDefinitionText} [${elementId}]: ${reaction}")
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        if (elementIndex == orderedElements.lastIndex) {
                                            Div({
                                                style {
                                                    gridColumn("1 / -1"); width(100.percent)
                                                    display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(14.px)
                                                    margin(12.px, 0.px, 14.px)
                                                }
                                            }) {
                                                Div({ style { flex("1"); height(1.px); property("background", "rgba(255,255,255,.42)") } }) { }
                                                LumaticaButton("Weiter", {
                                                    log(type, "Bereich abgeschlossen: ${type}")
                                                    onStageChange(step + 1)
                                                }, variant = LumaticaButtonVariant.Action, enabled = live && stage == step,
                                                    heightPx = 48, paddingH = 18, disabledVisualOpacity = 1.0)
                                                Div({ style { flex("1"); height(1.px); property("background", "rgba(255,255,255,.42)") } }) { }
                                            }
                                        }
                                    }
                                }
                }
            }
}

@Composable
private fun ConversationStep(title: String, step: Int, currentStep: Int, content: @Composable () -> Unit) {
    val active = step == currentStep
    Div({
        id("akquise-step-$step")
        style {
            position(Position.Relative); padding(18.px, 16.px, 22.px, 28.px)
            property("border-left", if (active) "5px solid ${UISettings.ACCENT}" else "1px solid rgba(255,255,255,.28)")
            textAlign("center"); lineHeight("1.55")
            opacity(1)
        }
    }) {
        Div({ style { position(Position.Relative); fontSize(19.px); fontWeight("700"); textAlign("center"); marginBottom(18.px) } }) {
            Span({ style {
                position(Position.Absolute); left((-32).px); top(50.percent); property("transform", "translateY(-50%)")
                width(if (active) 12.px else 7.px); height(if (active) 12.px else 7.px); borderRadius(50.percent)
                if (active) backgroundColor(UISettings.ACCENT) else backgroundColor(Color("rgba(255,255,255,.65)"))
                property("box-shadow", if (active) "0 0 0 4px rgba(255,255,255,.12)" else "none")
            } })
            Text(title)
        }
        content()
    }
}

@Composable
private fun FlowChoiceRow(label: String, selected: Boolean, enabled: Boolean, onClick: () -> Unit) {
    var hovered by remember { mutableStateOf(false) }
    Div({
        attr("role", "button")
        attr("aria-pressed", selected.toString())
        if (enabled) {
            attr("tabindex", "0")
            onClick { onClick() }
        }
        onMouseEnter { hovered = true }
        onMouseLeave { hovered = false }
        style {
            width(100.percent)
            minWidth(0.px)
            minHeight(38.px)
            boxSizing("border-box")
            display(DisplayStyle.Flex)
            alignItems(AlignItems.FlexStart)
            gap(10.px)
            padding(7.px, 10.px)
            color(Color("#F7F7F5"))
            fontSize(15.px)
            lineHeight("1.4")
            fontWeight(if (selected) "650" else "500")
            property("cursor", if (enabled) "pointer" else "default")
            property("border-left", if (selected) "3px solid ${UISettings.ACCENT}" else "3px solid transparent")
            property("border-radius", "3px")
            property("background", when {
                selected -> UISettings.accentRgba(0.12)
                hovered && enabled -> "rgba(255,255,255,.065)"
                else -> "transparent"
            })
            property("transition", "background .14s ease, border-color .14s ease")
            property("overflow-wrap", "anywhere")
        }
    }) {
        Span({ style { flexShrink(0); color(if (selected) UISettings.ACCENT else Color("rgba(255,255,255,.74)")); fontWeight("700") } }) { Text("›") }
        Span({ style { minWidth(0.px); textAlign("left"); property("white-space", "pre-wrap") } }) { Text(label) }
    }
}

